import { instance } from "../apiBase/instance";
import { MintNFTRequestType, NFTAirdropAllocationType, NFTAirdropType, NFTType, ResponseType, UserMintedType } from "../type";
import { AirdropNFTEnum } from "../type/enum";

export const getNFTGenesisCollection = async (): Promise<NFTType> => {
  const response = await instance.get(`api/nft-collections/genesis-collection`);
  return response.data.data;
};

export const getUserGenesisCollection = async (
  address: string
): Promise<UserMintedType> => {
  const response = await instance.get(
    `api/nfts/genesis-collection/user/${address}`
  );
  return response.data.data;
};

export const getNFTWhitelist = async (
  address: string
): Promise<{ id: number; address: string }> => {
  const response = await instance.get(
    `api/mint-nft-whitelists/user/${address}`
  );
  return response.data.data;
};

export const getRequestMint = async (address: string): Promise<MintNFTRequestType> => {
  const response = await instance.get(
    `api/mint-nft-whitelists/request-mint/user/${address}`
  );
  return response.data.data;
};

export const updateMintedNFT = async (address: string) : Promise<UserMintedType> => {
  const response = await instance.put(
    `api/nfts/update-minted-nft/${address}`
  );
  return response.data.data;
}

// NFT AIRDROP SECTION:

export const getAirdropNFT = async (
  address: string,
  page: number,
  limit: number,
  keySearch: string,
  type: AirdropNFTEnum
): Promise<ResponseType<NFTAirdropType>> => {
  const response = await instance.get(
    `api/nft-airdrops/user/${address}?page=${page}&limit=${limit}&type=${type}&search=${keySearch}`
  );
  return response.data;
};

export const updateTransactionNFT = async (id: number, body: {hash: string}) : Promise<NFTAirdropAllocationType> => {
  const response = await instance.put(
    `/api/nft-airdrop-allocations/update-transaction/${id}`,body);

  return response.data.data;
}
